// src/index.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "./index.css";
import "./styles/_variables.css";
import "./styles/_global.css";
import "./styles/_utils.css";
import "./styles/_antDesign.css";
import "./styles/_global.css";
import { configService } from "./services/configService";
import 'react-phone-number-input/style.css';
const root = ReactDOM.createRoot(document.getElementById("root"));

(async () => {
	await configService.load();

	const [
		{ default: AppProduction },
		{ BrowserRouter },
		{ default: reportWebVitals },
	] = await Promise.all([
		import("./AppProduction"),
		import("react-router-dom"),
		import("./reportWebVitals"),
	]);

	root.render(
		<BrowserRouter>
			<AppProduction />
		</BrowserRouter>,
	);

	reportWebVitals?.();
})();
